module.exports = __webpack_public_path__ + "img/lg_ring_y_i_0_0@2x.c9a3935e.png";